import "core-js/modules/es.array.reverse.js";
var _class, _TableAutomaticStylesStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { uniq } from "lodash-es";
import { computed, makeObservable } from "mobx";
import filterOutUndefined from "../Core/filterOutUndefined";
import isDefined from "../Core/isDefined";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import { ShortReportTraits } from "../Traits/TraitsClasses/CatalogMemberTraits";
import TableChartStyleTraits, { TableChartLineStyleTraits } from "../Traits/TraitsClasses/Table/ChartStyleTraits";
import TableColorStyleTraits from "../Traits/TraitsClasses/Table/ColorStyleTraits";
import TablePointSizeStyleTraits from "../Traits/TraitsClasses/Table/PointSizeStyleTraits";
import TableStyleTraits from "../Traits/TraitsClasses/Table/StyleTraits";
import TableTimeStyleTraits from "../Traits/TraitsClasses/Table/TimeStyleTraits";
import TableTraits from "../Traits/TraitsClasses/Table/TableTraits";
import TableColumnType from "./TableColumnType";
import { ImageryParts } from "../ModelMixins/MappableMixin";
const DEFAULT_ID_COLUMN = "id";
let TableAutomaticStylesStratum = (_class = (_TableAutomaticStylesStratum = class TableAutomaticStylesStratum extends LoadableStratum(TableTraits) {
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new TableAutomaticStylesStratum(newModel);
  }
  get rectangle() {
    return this.catalogItem.activeTableStyle.rectangle;
  }
  get disableOpacityControl() {
    // disable opacity control for point tables - or if no mapItems
    return this.catalogItem.activeTableStyle.isPoints() || this.catalogItem.mapItems.length === 0 ? true : undefined;
  }
  get disableSplitter() {
    return !this.catalogItem.mapItems.find(ImageryParts.is) ? true : undefined;
  }

  /**
   * Set default activeStyle to first style with a scalar color column (if none is found then find first style with enum, text and then region)
   * Ignores styles with `hidden: true`
   */
  get activeStyle() {
    if (this.catalogItem.styles && this.catalogItem.styles.length > 0) {
      // Find default active style in this order:
      // - First scalar style
      // - First enum style
      // - First text style
      // - First region style

      const types = [TableColumnType.scalar, TableColumnType.enum, TableColumnType.text, TableColumnType.region];
      const firstStyleOfEachType = types.map(columnType => {
        var _this$catalogItem$sty;
        return (_this$catalogItem$sty = this.catalogItem.styles.filter(style => !style.hidden).find(s => {
          var _this$catalogItem$fin, _s$color;
          return ((_this$catalogItem$fin = this.catalogItem.findColumnByName((_s$color = s.color) === null || _s$color === void 0 ? void 0 : _s$color.colorColumn)) === null || _this$catalogItem$fin === void 0 ? void 0 : _this$catalogItem$fin.type) === columnType;
        })) === null || _this$catalogItem$sty === void 0 ? void 0 : _this$catalogItem$sty.id;
      });
      return filterOutUndefined(firstStyleOfEachType)[0];
    }
  }
  get defaultStyle() {
    // Use the default style to select the spatial key (lon/lat, region, none i.e. chart)
    // for all styles.
    const longitudeColumn = this.catalogItem.findFirstColumnByType(TableColumnType.longitude);
    const latitudeColumn = this.catalogItem.findFirstColumnByType(TableColumnType.latitude);
    const regionColumn = this.catalogItem.findFirstColumnByType(TableColumnType.region);
    const timeColumn = this.catalogItem.findFirstColumnByType(TableColumnType.time);

    // Set a default id column only when we also have a time column
    const idColumn = timeColumn && this.catalogItem.findColumnByName(DEFAULT_ID_COLUMN);
    if (regionColumn !== undefined || longitudeColumn !== undefined && latitudeColumn !== undefined) {
      return createStratumInstance(TableStyleTraits, {
        longitudeColumn: longitudeColumn && latitudeColumn ? longitudeColumn.name : undefined,
        latitudeColumn: longitudeColumn && latitudeColumn ? latitudeColumn.name : undefined,
        regionColumn: regionColumn ? regionColumn.name : undefined,
        time: createStratumInstance(TableTimeStyleTraits, {
          timeColumn: timeColumn === null || timeColumn === void 0 ? void 0 : timeColumn.name,
          idColumns: idColumn && [idColumn.name]
        })
      });
    }

    // This dataset isn't spatial, so see if we have a valid chart style
    if (this.defaultChartStyle) {
      return this.defaultChartStyle;
    }

    // Can't do much with this dataset.
    // Just add default legend
    return createStratumInstance(TableStyleTraits, {});
  }
  get defaultChartStyle() {
    const timeColumns = this.catalogItem.tableColumns.filter(column => column.type === TableColumnType.time);
    const scalarColumns = this.catalogItem.tableColumns.filter(column => column.type === TableColumnType.scalar);
    const hasTime = timeColumns.length > 0;
    if (scalarColumns.length >= (hasTime ? 1 : 2)) {
      return createStratumInstance(TableStyleTraits, {
        chart: createStratumInstance(TableChartStyleTraits, {
          xAxisColumn: hasTime ? timeColumns[0].name : scalarColumns[0].name,
          lines: scalarColumns.slice(hasTime ? 0 : 1).map((column, i) => createStratumInstance(TableChartLineStyleTraits, {
            yAxisColumn: column.name,
            isSelectedInWorkbench: i === 0 // activate only the first chart line by default
          }))
        })
      });
    }
  }
  get styles() {
    // If no styles for scalar, enum - show styles using region columns
    const showRegionStyles = this.catalogItem.tableColumns.every(column => column.type !== TableColumnType.scalar && column.type !== TableColumnType.enum);
    const columnStyles = this.catalogItem.tableColumns.map((column, _i) => createStratumInstance(TableStyleTraits, {
      id: column.name,
      color: createStratumInstance(TableColorStyleTraits, {
        colorColumn: column.name
      }),
      pointSize: createStratumInstance(TablePointSizeStyleTraits, {
        pointSizeColumn: column.name
      }),
      hidden: column.type !== TableColumnType.scalar && column.type !== TableColumnType.enum && (column.type !== TableColumnType.region || !showRegionStyles)
    }));
    return [...columnStyles,
    // Create "User Style" traits for legend
    // This style is used by `TableStylingWorkflow` if no other styles are available
    createStratumInstance(TableStyleTraits, {
      id: "User Style",
      hidden: true
    })];
  }
  get disableDateTimeSelector() {
    if (this.catalogItem.mapItems.length === 0 || !this.catalogItem.activeTableStyle.moreThanOneTimeInterval) return true;
  }
  get showDisableTimeOption() {
    // Return nothing if no row groups or if time column doesn't have at least one interval
    if (this.catalogItem.activeTableStyle.rowGroups.length === 0 || !this.catalogItem.activeTableStyle.moreThanOneTimeInterval) return undefined;

    // Return true if at least 50% of rowGroups only have one unique time interval (i.e. they don't change over time)
    let flat = 0;
    for (let i = 0; i < this.catalogItem.activeTableStyle.rowGroups.length; i++) {
      const [_rowGroupId, rowIds] = this.catalogItem.activeTableStyle.rowGroups[i];
      // Check if there is only 1 unique date in this rowGroup
      const dates = rowIds.map(rowId => {
        var _this$catalogItem$act;
        return (_this$catalogItem$act = this.catalogItem.activeTableStyle.timeColumn) === null || _this$catalogItem$act === void 0 || (_this$catalogItem$act = _this$catalogItem$act.valuesAsDates.values[rowId]) === null || _this$catalogItem$act === void 0 ? void 0 : _this$catalogItem$act.getTime();
      }).filter(isDefined);
      if (uniq(dates).length <= 1) flat++;
    }
    if (flat / this.catalogItem.activeTableStyle.rowGroups.length >= 0.5) return true;
    return undefined;
  }
  get initialTimeSource() {
    return "start";
  }

  /** Return title of timeColumn if defined
   * This will be displayed on DateTimeSelectorSection in the workbench
   */
  get timeLabel() {
    if (this.catalogItem.activeTableStyle.timeColumn) {
      return "".concat(this.catalogItem.activeTableStyle.timeColumn.title, ": ");
    }
  }
  get shortReport() {
    return this.catalogItem.mapItems.length === 0 && this.catalogItem.chartItems.length === 0 && !this.catalogItem.isLoading ? i18next.t("models.tableData.noData") : undefined;
  }

  /** Show "Regions: xxx" short report for region-mapping */
  get shortReportSections() {
    const regionCol = this.catalogItem.activeTableStyle.regionColumn;
    const regionType = regionCol === null || regionCol === void 0 ? void 0 : regionCol.regionType;
    if (regionType && this.catalogItem.showingRegions) {
      return [createStratumInstance(ShortReportTraits, {
        name: "**Regions:** ".concat(regionType.description)
      })];
    }
    return [];
  }

  /** Show chart by default - if not loading and no mappable items */
  get showInChartPanel() {
    return this.catalogItem.show && !this.catalogItem.isLoading && this.catalogItem.mapItems.length === 0;
  }
}, _defineProperty(_TableAutomaticStylesStratum, "stratumName", "automaticTableStyles"), _TableAutomaticStylesStratum), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableOpacityControl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableOpacityControl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableSplitter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableSplitter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultChartStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultChartStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "styles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "styles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableDateTimeSelector", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableDateTimeSelector"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDisableTimeOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDisableTimeOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialTimeSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "initialTimeSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReportSections", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReportSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showInChartPanel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showInChartPanel"), _class.prototype), _class);
export { TableAutomaticStylesStratum as default };